var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.click}},[_c('img',{staticClass:"img_full_2",attrs:{"id":"main_img","alt":"cartoon1_back","src":require("../assets/images/background/0컷배치예시.jpg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }